import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';

import LoginContent from '~pages/auth/login-content';
import ResetPassword from './reset-password';
import ResetPasswordSuccessful from './reset-password/successful';
import SetPassword from './reset-password/reset';
import generatePath from '~client/settings/routing';
import BgImage from '~images/illustrator.png';

const useStyles = makeStyles(theme => ({
  auth: {
    display: 'flex',
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
  },
  sidebar: {
    width: '44%',
    backgroundColor: theme.colors.gray11,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundImage: `url(${BgImage})`,
    overflow: 'hidden',

    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  container: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '56%',
    minWidth: 628,
    height: '100%',
    backgroundColor: theme.colors.gray1,

    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  wrapperInner: {
    width: 480,
  },
}));

const Auth = ({ location }) => {
  const classes = useStyles();
  const { token } = useSelector(({ auth }) => ({
    token: auth.getIn(['base', 'token']),
  }));

  if (token) {
    const search = queryString.parse(location.search);
    return <Redirect to={search.redirectUrl || generatePath('board', {}, search)} />;
  }

  return (
    <section className={classes.auth}>
      <aside className={classes.sidebar} />
      <aside className={classes.container}>
        <div className={classes.wrapperInner}>
          <Route path="/login" component={LoginContent} />
          <Route path="/reset-password/:email?" exact component={ResetPassword} />
          <Route path="/reset-password/:email/success" component={ResetPasswordSuccessful} />
          <Route path="/set-password" component={SetPassword} />
        </div>
      </aside>
    </section>
  );
};

Auth.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
};

Auth.defaultProps = {
  location: {
    search: '',
  },
};

export default Auth;
